import * as C from '../Constants';
export function fetchResourceData(search_City){

    return function(dispatch){
        dispatch(requestPosts());
        fetch('https://api.covid19india.org/resources/resources.json')
        .then(res => res.json())
        .then(resource => {
          dispatch(fetchResourceSuccess(resource, search_City));
          return resource; 
     
        })
       
    }

}
export const requestPosts = () => ({
    type: C.SEARCH_RES,
    });
export const fetchResourceSuccess = (resource,search_City) => (
    
    
    {
    type: C.SEARCH_RES_SUCCESS,
    resource: search_City !== ""?   
        resource.resources.filter(item => item['city'].toLowerCase().includes(search_City.toLowerCase()))
        : resource.resources
     ,
    });